import { createWithEqualityFn } from 'zustand/traditional';

export interface IncomingCallNotification {
  id: string; // Уникальный ID уведомления
  notificationId: number; // ID из БД
  phoneNumber: string;
  asteriskId: string;
  customerId: number | null; // null = не найден, >0 = один абонент, <0 = несколько абонентов
  htmlMessage: string; // HTML сообщение из backend
  timestamp: number;
  callerIdName?: string;
}

interface IncomingCallState {
  notifications: IncomingCallNotification[];
  activeNotification: IncomingCallNotification | null;
  
  addNotification: (notification: IncomingCallNotification) => void;
  removeNotification: (id: string) => void;
  setActiveNotification: (notification: IncomingCallNotification | null) => void;
  clearAll: () => void;
}

export const useIncomingCallStore = createWithEqualityFn<IncomingCallState>((set) => ({
  notifications: [],
  activeNotification: null,
  
  addNotification: (notification) =>
    set((state) => ({
      notifications: [notification, ...state.notifications],
      activeNotification: state.activeNotification || notification, // Автоматически показываем первое
    })),
  
  removeNotification: (id) =>
    set((state) => {
      const filtered = state.notifications.filter((n) => n.id !== id);
      return {
        notifications: filtered,
        activeNotification:
          state.activeNotification?.id === id
            ? filtered[0] || null
            : state.activeNotification,
      };
    }),
  
  setActiveNotification: (notification) => set({ activeNotification: notification }),
  
  clearAll: () => set({ notifications: [], activeNotification: null }),
}));

